import { Document, LessonPlan, Quiz, Game, TeachingModel, QuestionType, Presentation, Homework, HomeworkTaskType, GradeLevel, GameType, SlideLayoutType, QuizSystem, QuizCategory, QuizFormat, Activity, ActivityType, Student, Class, ClassSession, Child } from '../types';

export const mockDocuments: Document[] = [
  { 
    id: '1', 
    name: 'Introduction to Photosynthesis.pptx', 
    type: 'pptx', 
    uploadDate: '2024-07-20', 
    status: 'published',
    content: 'Quang hợp là quá trình cây xanh và một số sinh vật khác chuyển đổi năng lượng ánh sáng thành năng lượng hóa học. Trong quá trình này, năng lượng ánh sáng được thu nhận và sử dụng để chuyển đổi nước, carbon dioxide và khoáng chất thành oxy và các hợp chất hữu cơ giàu năng lượng.\n\nChương 1: Các giai đoạn của quang hợp.\n- Giai đoạn phụ thuộc ánh sáng: Xảy ra ở màng thylakoid, chuyển đổi năng lượng ánh sáng thành ATP và NADPH.\n- Giai đoạn không phụ thuộc ánh sáng (Chu trình Calvin): Xảy ra trong chất nền stroma, sử dụng ATP và NADPH để cố định CO2 và tạo ra đường glucose.'
  },
  { 
    id: '2', 
    name: 'The Cell Cycle Worksheet.docx', 
    type: 'docx', 
    uploadDate: '2024-07-19', 
    status: 'draft',
    content: 'Chu kỳ tế bào là một chuỗi các sự kiện diễn ra trong một tế bào dẫn đến sự phân chia và nhân đôi của nó. Chu kỳ này bao gồm hai giai đoạn chính: kỳ trung gian và pha M (nguyên phân).\n\nKỳ trung gian bao gồm các pha G1, S và G2. Trong pha G1, tế bào phát triển. Trong pha S, DNA được nhân đôi. Trong pha G2, tế bào tiếp tục phát triển và chuẩn bị cho nguyên phân.'
  },
  { 
    id: '3', 
    name: 'History of Ancient Rome.pdf', 
    type: 'pdf', 
    uploadDate: '2024-07-18', 
    status: 'published',
    content: 'Lịch sử La Mã cổ đại kéo dài từ khi thành lập thành phố vào năm 753 TCN cho đến sự sụp đổ của Đế chế Tây La Mã vào năm 476 SCN. Lịch sử này được chia thành ba giai đoạn chính: Vương quốc La Mã, Cộng hòa La Mã và Đế chế La Mã.\n\nCộng hòa La Mã (509 TCN - 27 TCN) được đặc trưng bởi một chính phủ cộng hòa, với các quan chức được bầu hàng năm. Julius Caesar là một nhân vật quan trọng trong giai đoạn cuối của Cộng hòa.'
  },
  { 
    id: '4', 
    name: 'Ghi-chu-Lich-su-Viet-Nam.txt', 
    type: 'txt', 
    uploadDate: '2024-07-21', 
    status: 'draft',
    content: 'Lịch sử Việt Nam là lịch sử của quốc gia và dân tộc Việt Nam từ thời tiền sử cho đến ngày nay.\n\nThời kỳ Bắc thuộc lần thứ nhất (111 TCN – 40 SCN): Nhà Triệu của Trung Quốc xâm lược và sáp nhập Âu Lạc. Các cuộc khởi nghĩa của Hai Bà Trưng đã nổ ra để chống lại ách đô hộ.\n\nNhà Lý (1009–1225): Lý Công Uẩn lên ngôi, dời đô về Thăng Long (Hà Nội ngày nay). Đây là một triều đại thịnh vượng với nhiều thành tựu về văn hóa và quân sự.'
  },
];

export const mockLessonPlans: LessonPlan[] = [
    {
        id: 'lp1',
        title: 'Giáo án bài Quang hợp',
        gradeLevel: GradeLevel.THPT,
        subject: 'Sinh học',
        model: TeachingModel.FiveE,
        savedDate: '2024-07-22',
        sourceDocumentId: '1', // Linked to the Photosynthesis PPTX
        teachingDuration: 45,
        steps: [
            { step: 'Gắn kết', duration: '5 phút', teacherActivity: 'Đặt câu hỏi về cây xanh.', studentActivity: 'Trả lời câu hỏi.', teachingAids: 'Hình ảnh cây xanh', competencyGoals: ['Nêu được câu hỏi.'] },
            { step: 'Khám phá', duration: '15 phút', teacherActivity: 'Hướng dẫn thí nghiệm.', studentActivity: 'Làm thí nghiệm.', teachingAids: 'Dụng cụ thí nghiệm', competencyGoals: ['Thực hiện thí nghiệm.'] },
        ]
    },
    {
        id: 'lp2',
        title: 'Bài giảng về Các triều đại Việt Nam',
        gradeLevel: GradeLevel.THPT,
        subject: 'Lịch sử',
        model: TeachingModel.GDPT_2018_5512,
        savedDate: '2024-07-21',
        teachingDuration: 45,
        steps: [
            { step: 'Khởi động', duration: '7 phút', teacherActivity: 'Chiếu video về lịch sử.', studentActivity: 'Xem video và thảo luận.', teachingAids: 'Video, máy chiếu', competencyGoals: ['Tóm tắt được nội dung video.'] },
        ]
    }
];

export const mockQuizzes: Quiz[] = [
    {
        id: 'q1',
        title: 'Kiểm tra nhanh: Quang hợp',
        gradeLevel: GradeLevel.THPT,
        subject: 'Sinh học',
        savedDate: '2024-07-22',
        // FIX: Added missing properties to satisfy the Quiz type.
        system: QuizSystem.CONG_LAP,
        category: QuizCategory.THUONG_XUYEN,
        format: QuizFormat.TRAC_NGHIEM_NHANH,
        questions: [
            { questionText: 'Quang hợp là gì?', questionType: QuestionType.ShortAnswer, correctAnswer: 'Là quá trình cây xanh sử dụng ánh sáng mặt trời để tổng hợp chất hữu cơ.', explanation: 'Đây là định nghĩa cơ bản.' },
            { questionText: 'Sản phẩm của quang hợp là gì?', questionType: QuestionType.MultipleChoice, options: ['O2 và Glucose', 'CO2 và nước', 'Nito', 'Photpho'], correctAnswer: 'O2 và Glucose', explanation: 'O2 và Glucose là hai sản phẩm chính.'}
        ]
    },
     {
        id: 'q2',
        title: 'Kiểm tra 15 phút: Lịch sử',
        gradeLevel: GradeLevel.THCS,
        subject: 'Lịch sử',
        savedDate: '2024-07-21',
        // FIX: Added missing properties to satisfy the Quiz type.
        system: QuizSystem.CONG_LAP,
        category: QuizCategory.DINH_KY,
        format: QuizFormat.TRAC_NGHIEM_KHACH_QUAN,
        questions: [
            { questionText: 'Vị vua đầu tiên của nhà Lý là ai?', questionType: QuestionType.MultipleChoice, options: ['Lý Thái Tổ', 'Lý Thái Tông', 'Lý Thánh Tông', 'Lý Nhân Tông'], correctAnswer: 'Lý Thái Tổ', explanation: 'Lý Công Uẩn lên ngôi vua năm 1009, lấy niên hiệu là Thuận Thiên, sáng lập ra nhà Lý.' },
        ]
    }
];

export const mockGames: Game[] = [
    {
        id: 'g1',
        title: 'Bingo Lịch sử Việt Nam',
        gradeLevel: GradeLevel.THCS,
        gameType: GameType.BINGO_KIEN_THUC,
        topic: "Các triều đại Việt Nam",
        content: { bingoItems: ["Hội nghị Diên Hồng", "Nhà Trần", "Lý Công Uẩn", "Sông Bạch Đằng", "Ngô Quyền", "Dời đô về Thăng Long", "Nhà Hậu Lê", "Vua Quang Trung", "Khởi nghĩa Lam Sơn", "Bình Ngô đại cáo", "Trần Hưng Đạo", "Chiến thắng Như Nguyệt", "Lê Lợi", "Nhà Nguyễn", "Kinh thành Huế", "Trận Rạch Gầm - Xoài Mút"]},
        rules: "Giáo viên đọc định nghĩa hoặc gợi ý, học sinh đánh dấu vào ô có từ khóa tương ứng. Ai có được một hàng ngang, dọc hoặc chéo trước sẽ thắng.",
        savedDate: '2024-07-25',
    }
];

export const mockPresentations: Presentation[] = [
    {
        id: 'p1',
        title: 'Bài giảng Quang hợp',
        savedDate: '2024-07-23',
        slides: [
            { slideType: SlideLayoutType.Concept, title: 'Slide 1: Giới thiệu', content: { explanation: 'Quang hợp là gì?' }, speakerNotes: 'Hỏi học sinh về định nghĩa quang hợp.' },
            { slideType: SlideLayoutType.Analysis, title: 'Slide 2: Quá trình', content: { mainPoints: ['Các giai đoạn chính.'] }, speakerNotes: 'Giải thích chi tiết từng giai đoạn.' }
        ]
    },
    {
        id: 'p2',
        title: 'Tổng quan Lịch sử Việt Nam',
        savedDate: '2024-07-22',
        slides: [
            { slideType: SlideLayoutType.Concept, title: 'Slide 1: Thời kỳ Hùng Vương', content: { explanation: 'Giới thiệu về nhà nước Văn Lang.' }, speakerNotes: 'Nhấn mạnh vai trò của các vua Hùng.' }
        ]
    }
];

export const mockHomeworks: Homework[] = [
    {
        id: 'hw1',
        title: 'Bài tập về nhà: Quang hợp',
        savedDate: '2024-07-23',
        dueDateSuggestion: 'Thứ Tư tuần này',
        tasks: [
            { taskType: HomeworkTaskType.Questions, description: 'Nêu vai trò của diệp lục trong quá trình quang hợp.' },
            { taskType: HomeworkTaskType.Drawing, description: 'Vẽ sơ đồ tư duy tóm tắt các yếu tố ảnh hưởng đến quang hợp.'}
        ]
    }
];

export const mockActivities: Activity[] = [
    {
        id: 'act1',
        title: 'Bài hát về Vòng tuần hoàn của nước',
        gradeLevel: GradeLevel.TIEU_HOC,
        activityType: ActivityType.SONG_LYRICS,
        objective: 'Giúp học sinh ghi nhớ các giai đoạn của vòng tuần hoàn nước: bay hơi, ngưng tụ, mưa.',
        content: '(Trên nền nhạc bài "Bắc Kim Thang")\n\nNước ở sông, rồi bay lên trời,\nGặp lạnh liền, hoá thành mây bay,\nMây nặng hạt, mưa lại rơi xuống,\nNước lại về, với biển sông quê...',
        savedDate: '2024-07-28',
    }
];

export const mockChildren: Child[] = [
    { id: 'child1', name: 'Nguyễn Văn An', dob: '2016-05-15', gender: 'male', studentId: 'HS001' },
    { id: 'child2', name: 'Nguyễn Văn Hùng', dob: '2010-10-10', gender: 'male', studentId: 'approved_1' }
];
export const mockStudents: Student[] = [
    { 
        id: 's1', 
        name: 'Nguyễn Văn An', 
        studentId: 'HS001', 
        dob: '2016-05-15',
        loginCode: '123456',
        parents: [
            { id: 'p1', name: 'Nguyễn Văn Bình', phoneNumber: '0912345678', relationship: 'Bố' },
            { id: 'p2', name: 'Trần Thị Mai', phoneNumber: '0987654321', relationship: 'Mẹ' }
        ]
    },
    { 
        id: 's2', 
        name: 'Trần Thị Bình', 
        studentId: 'HS002',
        dob: '2016-08-20',
        loginCode: '654321',
        parents: [
            { id: 'p3', name: 'Trần Văn Hùng', phoneNumber: '0900111222', relationship: 'Bố' }
        ]
    },
    {
        id: 's3',
        name: 'Lê Văn Cường',
        studentId: 'HS003',
        dob: '2016-12-01',
        loginCode: '111222',
        parents: [
            { id: 'p4', name: 'Lê Văn Dũng', phoneNumber: '0933444555', relationship: 'Bố' },
            { id: 'p5', name: 'Phạm Thị Lan', phoneNumber: '0944555666', relationship: 'Mẹ' }
        ]
    },
    {
        id: 's4',
        name: 'Phạm Minh Đức',
        studentId: 'HS004',
        dob: '2015-03-10',
        loginCode: '333444',
        parents: [
            { id: 'p6', name: 'Phạm Văn Em', phoneNumber: '0955666777', relationship: 'Bố' }
        ]
    },
    {
        id: 's5',
        name: 'Hoàng Thị Hoa',
        studentId: 'HS005',
        dob: '2017-01-25',
        loginCode: '555666',
        parents: [
            { id: 'p7', name: 'Hoàng Văn Giang', phoneNumber: '0966777888', relationship: 'Bố' },
            { id: 'p8', name: 'Đỗ Thị Hương', phoneNumber: '0977888999', relationship: 'Mẹ' }
        ]
    }
];

export const mockClasses: Class[] = [
    {
        id: 'c1',
        name: 'Toán nâng cao 4A1',
        academicYear: '2025-2026',
        gradeLevel: GradeLevel.TIEU_HOC,
        studentIds: ['s1', 's2', 's3', 's4', 's5'],
        classType: 'offline',
        teacherName: 'Cô Lan',
        teacherPhone: '0912345678',
        inviteCode: 'MATH4A',
        sessions: [
            {
                id: 'sess1',
                date: '2025-02-01',
                title: 'Buổi 1: Ôn tập số học & Phép nhân',
                grades: [
                    { studentId: 's1', attendance: 'present', grade: '9', note: 'Phát biểu hăng hái, nắm vững kiến thức' },
                    { studentId: 's2', attendance: 'present', grade: '8.5', note: 'Làm bài tốt, cần cẩn thận hơn' },
                    { studentId: 's3', attendance: 'present', grade: '7.5', note: 'Tiếp thu bài ổn' },
                    { studentId: 's4', attendance: 'late', grade: '6.5', note: 'Đi muộn 10p, cần tập trung hơn' },
                    { studentId: 's5', attendance: 'present', grade: '9.5', note: 'Xuất sắc' }
                ]
            },
            {
                id: 'sess2',
                date: '2025-02-08',
                title: 'Buổi 2: Hình học - Diện tích tam giác',
                grades: [
                    { studentId: 's1', attendance: 'late', grade: '7', note: 'Đi muộn 15p, chưa thuộc công thức' },
                    { studentId: 's2', attendance: 'present', grade: '9', note: 'Vẽ hình rất đẹp và chính xác' },
                    { studentId: 's3', attendance: 'absent', grade: '', note: 'Nghỉ có phép' },
                    { studentId: 's4', attendance: 'present', grade: '8', note: 'Có tiến bộ so với buổi trước' },
                    { studentId: 's5', attendance: 'present', grade: '9', note: 'Làm bài nhanh nhất lớp' }
                ]
            },
            {
                id: 'sess3',
                date: '2025-02-15',
                title: 'Buổi 3: Giải bài toán bằng cách lập phương trình',
                grades: [
                    { studentId: 's1', attendance: 'present', grade: '8.5', note: 'Đã cải thiện sự tập trung' },
                    { studentId: 's2', attendance: 'present', grade: '8', note: 'Trình bày còn hơi tắt' },
                    { studentId: 's3', attendance: 'present', grade: '9', note: 'Học bù bài cũ rất tốt' },
                    { studentId: 's4', attendance: 'present', grade: '7', note: 'Cần rèn luyện thêm kỹ năng tính toán' },
                    { studentId: 's5', attendance: 'present', grade: '10', note: 'Hoàn hảo' }
                ]
            }
        ]
    },
    {
        id: 'c2',
        name: '9A2 - Tiếng Anh Giao tiếp Online',
        academicYear: '2025-2026',
        gradeLevel: GradeLevel.THCS,
        studentIds: [], // Members managed via approvedStudents in App.tsx for online demo
        classType: 'online',
        inviteCode: 'NNAM6J',
        teacherName: 'Thầy Hùng',
        teacherPhone: '0987654321',
        sessions: [
            {
                id: 'sess4',
                date: '2025-02-05',
                title: 'Unit 1: Life stories - Speaking session',
                grades: [
                    { studentId: 'approved_1', attendance: 'present', grade: '10', note: 'Excellent pronunciation and fluency' }
                ]
            },
            {
                id: 'sess5',
                date: '2025-02-12',
                title: 'Unit 2: Urbanization - Vocabulary & Grammar',
                grades: [
                    { studentId: 'approved_1', attendance: 'present', grade: '9.5', note: 'Nắm vững từ vựng mới' }
                ]
            }
        ]
    },
    {
        id: 'c3',
        name: 'Lớp Vẽ Sáng tạo - Kid Art',
        academicYear: '2024-2025',
        gradeLevel: GradeLevel.MAM_NON,
        studentIds: ['s1', 's3', 's5'],
        classType: 'offline',
        teacherName: 'Cô Mai',
        teacherPhone: '0900111222',
        inviteCode: 'ARTKID',
        sessions: [
            {
                id: 'sess6',
                date: '2025-02-10',
                title: 'Phối màu cơ bản & Vẽ phong cảnh',
                grades: [
                    { studentId: 's1', attendance: 'present', grade: 'A+', note: 'Phối màu rất sáng tạo' },
                    { studentId: 's3', attendance: 'present', grade: 'A', note: 'Nét vẽ tự tin' },
                    { studentId: 's5', attendance: 'present', grade: 'A+', note: 'Bức tranh có chiều sâu' }
                ]
            }
        ]
    }
];
